import { WorkflowLayoutEntityModel } from "src/store/models/entity/workflowLayout/entity";
import { WorkflowLayoutHelperModel } from "src/store/models/entity/workflowLayout/helper";

export const encooWorkflowLayoutModels = {
  entity: WorkflowLayoutEntityModel,
  helper: WorkflowLayoutHelperModel,
};
